export const EventoSlug = (nombre, id) => {
    return  nombre.replace(' ', '&')+'-'+id;
}